import Vue from "vue";
import Vuex from "vuex";
import chat from "@/modules/Chat/store";
import { getBotInfo } from "@/domain/use-cases/GetBotInfo";
import { checkConversationStatus } from "@/infrastructure/database/firebase";

// import takeOver from "@/modules/TakeOverChat/store";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    bot: {},
    bot_id: undefined,
    config_landing: {}
  },

  mutations: {
    INSERT_BOT(state, bot) {
      state.bot = bot;
    },
    SET_BOT_INFO(state, {bot}){
      state.bot = bot;
    },
    SET_CONFIG_LANDING(state, {config_landing}){
      state.config_landing = config_landing;
    },
    INSERT_BOT_ID(state, {bot_id}) {
      state.bot_id = bot_id;
    }
  },

  actions: {
    setInfoBot({ commit }, bot) {
      return new Promise((resolve, reject) => {
        if (bot !== undefined) {
          resolve(commit("INSERT_BOT", bot));
        } else {
          reject();
        }
      });
    },

    async getBotStartup({ dispatch, commit }, { bot_alias_or_id, channel, anl }){
      try{
        const conversation_id = localStorage.getItem('conversation_id') ?? '';

        const responses = await Promise.all([
           getBotInfo({ channel, ...bot_alias_or_id, anl }),
           checkConversationStatus({...bot_alias_or_id, conversation_id})
        ])

        const botInfo = responses[0];
        const conversationStatus = responses[1];

        if(conversationStatus.status === 'closed') {
          localStorage.removeItem('conversation_id');
          localStorage.removeItem('opened_chat');
        }

        commit("INSERT_BOT_ID", {bot_id: botInfo.bot_id});

        let bot = {
          id: botInfo.bot_id,
          bot_id: botInfo.bot_id,
          name: botInfo.name,
          channel: botInfo.channel,
          white_label: !!botInfo.white_label,
          photo: botInfo.photo !== null && botInfo.photo !== undefined? botInfo.photo.publicPath: null,
          placeholder: (botInfo.config_landing?.placeholder ??  botInfo.config_widget?.placeholder )?? `Fale com ${botInfo.name}`
        }
        let config_landing = botInfo.config_landing ?? botInfo.config_widget;

        commit("SET_BOT_INFO", {bot});
        commit("SET_CONFIG_LANDING", {config_landing});

        const chatOpened = Boolean(localStorage.getItem('opened_chat'));
        if(conversationStatus.status !== 'closed' && chatOpened){
          dispatch("chat/showSimulator", chatOpened);
        }
        return bot;
    }

    catch(error) {
      Promise.reject(error);
      throw Error("bot not found");
    }

  }
  
  },
  modules: {
    chat
    },
});
